import React, { useEffect } from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";
import Validator from "./Validator.jsx";
import { useSelector, useDispatch } from "react-redux";
import { updateOverview } from "../../state/reducers/codeOverview";

function SecurityValidator() {

  const showOverview = useSelector((state) => state.codeOverview.showOverview)
  const showValidator = useSelector((state) => state.securityValidator.showValidator)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateOverview(false))
  }, [])

  return (
    <>
      {!showOverview && !showValidator && <CloneRepo />}
      {showValidator && <Validator />}
    </>
  );
}

export default SecurityValidator;